export default "__VITE_ASSET__202bd223__"